<div class="qr-wrapper" [class.processing]="!qr_data_to_encode">
  <div class="text-center" *ngIf="!qr_data_to_encode || !data || !_data?.qr_url; else dataExist">
    <!-- <img loading="lazy" src="assets/qr-generator/qr-code.png" class="dummy-qr" width="75%"> -->
    <img loading="lazy" src="assets/qr-illustration.png" width="80%">
  </div>

  <ng-template #dataExist>
    <div class="sticky-top bg-white py-3">
      <div class="qr-img" [class.disable-div]="_data.processing">
        <app-inline-loader version="v2" _class="v-large" *ngIf="!_data.qr_url; else allGood">
        </app-inline-loader>
        <ng-template #allGood>
          <ng-container *ngIf="!_data.style_settings.frame.type">
            <img loading="lazy" id="noframe_console" width="100%" [src]="_data.qr_url" />
          </ng-container>
          <ng-container *ngIf="frame_types.STYLE1 == _data.style_settings.frame.type">
            <!-- Frame 1 -->
            <svg [id]="'svg_' + _data.style_settings.frame.type" viewBox="0 0 659 814" height="100%" width="100%">
              <g id="QR-Generator" stroke="none" stroke-width="1"
                [attr.fill]="_data.style_settings.qr_style.backgroundOptions.color" fill-rule="evenodd">
                <g id="Desktop-HD-Copy" transform="translate(-196.000000, -171.000000)">
                  <g id="Group-2" transform="translate(196.000000, 171.000000)">
                    <g id="Group">
                      <rect id="Rectangle" [attr.stroke]="_data.style_settings.frame.color" stroke-width="30" x="15"
                        y="15" width="629" height="784" rx="50">
                      </rect>
                      <rect id="Rectangle" [attr.fill]="_data.style_settings.frame.color" x="23" y="633" width="615"
                        height="153"></rect>
                    </g>
                    <image x="60" y="60" width="540" height="540" [attr.xlink:href]="_data.qr_url">
                    </image>
                    <text class="noselect" font-family="ArialMT, Arial" font-size="90" font-weight="normal"
                      letter-spacing="0.375" x="50%" y="732" alignment-baseline="middle" text-anchor="middle"
                      fill="#FFFFFF">{{_data.style_settings.frame.text}}</text>
                  </g>
                </g>
              </g>
            </svg>
          </ng-container>
          <ng-container *ngIf="frame_types.STYLE2 == _data.style_settings.frame.type">
            <!-- Frame 2 -->
            <svg [id]="'svg_' + _data.style_settings.frame.type" viewBox="0 0 659 866" height="100%" width="100%">
              <g id="QR-Generator" stroke="none" stroke-width="1"
                [attr.fill]="_data.style_settings.qr_style.backgroundOptions.color" fill-rule="evenodd">
                <g id="Desktop-HD-Copy" transform="translate(-1317.000000, -171.000000)">
                  <g id="Group-3" transform="translate(1317.000000, 171.000000)">
                    <rect id="Rectangle" [attr.stroke]="_data.style_settings.frame.color" stroke-width="30" x="15"
                      y="15" width="629" height="629" rx="50"></rect>
                    <rect id="Rectangle" [attr.fill]="_data.style_settings.frame.color" x="0" y="689" width="659"
                      height="177" rx="88.5"></rect>
                    <image x="60" y="60" width="540" height="540" [attr.xlink:href]="_data.qr_url">
                    </image>
                    <text class="noselect" font-family="ArialMT, Arial" font-size="90" font-weight="normal"
                      letter-spacing="0.375" x="50%" y="786" alignment-baseline="middle" text-anchor="middle"
                      fill="#FFFFFF">{{_data.style_settings.frame.text}}</text>
                  </g>
                </g>
              </g>
            </svg>
          </ng-container>
          <ng-container *ngIf="frame_types.STYLE3 == _data.style_settings.frame.type">
            <!-- Frame 3 -->
            <svg [id]="'svg_' + _data.style_settings.frame.type" viewBox="0 0 659 866" height="100%" width="100%">
              <g id="QR-Generator" stroke="none" stroke-width="1"
                [attr.fill]="_data.style_settings.qr_style.backgroundOptions.color" fill-rule="evenodd">
                <g id="Desktop-HD-Copy" transform="translate(-2416.000000, -191.000000)">
                  <g id="Group-4" transform="translate(2416.000000, 191.000000)">
                    <rect id="Rectangle" [attr.stroke]="_data.style_settings.frame.color" stroke-width="30" x="15"
                      y="222" width="629" height="629" rx="50">
                    </rect>
                    <rect id="Rectangle" [attr.fill]="_data.style_settings.frame.color" x="0" y="0" width="659"
                      height="177" rx="20"></rect>
                    <image x="60" y="267" width="540" height="540" [attr.xlink:href]="_data.qr_url">
                    </image>
                    <text class="noselect" font-family="ArialMT, Arial" font-size="90" font-weight="normal"
                      letter-spacing="0.375" x="50%" y="100" alignment-baseline="middle" text-anchor="middle"
                      fill="#FFFFFF">{{_data.style_settings.frame.text}}</text>
                  </g>
                </g>
              </g>
            </svg>
          </ng-container>
          <ng-container *ngIf="frame_types.STYLE4 == _data.style_settings.frame.type">
            <!-- Frame 4 -->
            <svg [id]="'svg_' + _data.style_settings.frame.type" viewBox="0 0 659 821" height="100%" width="100%">
              <g stroke="none" stroke-width="1" [attr.fill]="_data.style_settings.qr_style.backgroundOptions.color"
                fill-rule="evenodd">
                <g transform="translate(-196.000000, -1355.000000)">
                  <g transform="translate(196.000000, 1355.000000)">
                    <rect [attr.stroke]="_data.style_settings.frame.color" stroke-width="30" x="19.5" y="19.5"
                      width="620" height="620" rx="50"></rect>
                    <image x="60" y="60" width="540" height="540" [attr.xlink:href]="_data.qr_url">
                    </image>
                    <text class="noselect" font-family="ArialMT, Arial" font-size="90" font-weight="normal"
                      letter-spacing="0.375" x="50%" y="740" alignment-baseline="middle" text-anchor="middle"
                      [attr.fill]="_data.style_settings.frame.color">{{_data.style_settings.frame.text}}</text>
                  </g>
                </g>
              </g>
            </svg>
          </ng-container>
          <ng-container *ngIf="frame_types.STYLE5 == _data.style_settings.frame.type">
            <!-- Frame 5 -->
            <svg [id]="'svg_' + _data.style_settings.frame.type" viewBox="0 0 817 1017" height="100%" width="100%">
              <g stroke="none" stroke-width="1" [attr.fill]="_data.style_settings.qr_style.backgroundOptions.color"
                fill-rule="evenodd">
                <g transform="translate(-1239.000000, -1355.000000)">
                  <g transform="translate(1239.000000, 1355.000000)">
                    <rect [attr.stroke]="_data.style_settings.frame.color" stroke-width="30" x="98.5" y="19.5"
                      width="620" height="620" rx="50"></rect>
                    <image x="139" y="60" width="540" height="540" [attr.xlink:href]="_data.qr_url">
                    </image>
                    <g id="prize-banner-" transform="translate(0.000000, 689.000000)"
                      [attr.fill]="_data.style_settings.frame.color" fill-rule="nonzero">
                      <polygon id="Path"
                        points="113.724138 241.125 113.724138 207.6875 113.724138 94 0 94 80.2758621 201 0 308 194 308 194 241.125 140.482759 241.125">
                      </polygon>
                      <polygon id="Path"
                        points="817 94 702.935484 94 702.935484 207.6875 702.935484 241.125 676.096774 241.125 609 241.125 609 308 817 308 736.483871 201">
                      </polygon>
                      <rect id="Rectangle" x="142" y="0" width="535" height="214"></rect>
                    </g>
                    <text class="noselect" font-family="ArialMT, Arial" font-size="90" font-weight="normal"
                      letter-spacing="0.375" x="50%" y="805" alignment-baseline="middle" text-anchor="middle"
                      fill="#FFFFFF">{{_data.style_settings.frame.text}}</text>
                  </g>
                </g>
              </g>
            </svg>
          </ng-container>
          <ng-container *ngIf="frame_types.STYLE6 == _data.style_settings.frame.type">
            <!-- Frame 6 -->
            <svg [id]="'svg_' + _data.style_settings.frame.type" viewBox="0 0 659 1133" height="100%" width="100%">
              <g stroke="none" stroke-width="1" [attr.fill]="_data.style_settings.qr_style.backgroundOptions.color"
                fill-rule="evenodd">
                <g transform="translate(-2472.000000, -1218.000000)">
                  <g transform="translate(2472.000000, 1218.000000)">
                    <rect [attr.stroke]="_data.style_settings.frame.color" stroke-width="30" x="19.5" y="19.5"
                      width="620" height="1094" rx="100"></rect>
                    <image x="60" y="202" width="540" height="540" [attr.xlink:href]="_data.qr_url">
                    </image>
                    <text font-family="ArialMT, Arial" font-size="90" font-weight="normal" letter-spacing="0.375"
                      x="50%" y="820" alignment-baseline="middle" text-anchor="middle"
                      [attr.fill]="_data.style_settings.frame.color">{{_data.style_settings.frame.text}}</text>
                    <rect [attr.fill]="_data.style_settings.frame.color" x="289" y="79" width="81" height="20" rx="10">
                    </rect>
                    <rect [attr.stroke]="_data.style_settings.frame.color" stroke-width="20" x="291" y="982" width="77"
                      height="77" rx="38.5"></rect>
                    <rect [attr.fill]="_data.style_settings.frame.color" x="28" y="137" width="603" height="30"></rect>
                    <rect [attr.fill]="_data.style_settings.frame.color" x="28" y="909" width="603" height="30"></rect>
                  </g>
                </g>
              </g>
            </svg>
          </ng-container>
        </ng-template>
      </div>
    </div>
    <div class="accordion accordion-wrapper v2 mt-5" id="accordionExample">
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingOne">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#qr-frame"
            aria-expanded="false" aria-controls="qr-frame">
            <i class="bi bi-fullscreen"></i> <b>FRAME</b>
          </button>
        </h2>
        <div id="qr-frame" class="accordion-collapse collapse" aria-labelledby="headingOne"
          data-bs-parent="#accordionExample">
          <div class="accordion-body">

            <ng-container *ngIf="_data.style_settings.frame.type">
              <div class="color-wrapper">
                <label class="form-label">Frame Color</label>
                <div class="color-contents">
                  <div class="dropdown">
                    <div class="color-box" [ngStyle]="{'background-color': _data.style_settings.frame.color}"
                      id="colorDropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
                    <div class="dropdown-menu color-picker-dropdown p-3" aria-labelledby="colorDropdown">
                      <sketch-picker [control]="chromeControl1" class="sketch-picker">
                      </sketch-picker>
                    </div>
                  </div>
                  <input type="text" [(ngModel)]="_data.style_settings.frame.color" (change)="regenerateQR()"
                    class="form-control">
                </div>
              </div>
              <div class="mt-3 mb-4">
                <label class="form-label">Frame Text</label>
                <input type="text" [(ngModel)]="_data.style_settings.frame.text" class="form-control" maxlength="16">
              </div>
            </ng-container>

            <div class="modal-frame-wrapper">
              <!-- No Frame -->
              <div class="frame" (click)="changeFrame()" [class.active]="!_data.style_settings.frame.type">
                <i class="bi bi-slash-circle"></i>
              </div>

              <!-- Frame 1 -->
              <div class="frame" (click)="changeFrame(frame_types.STYLE1)"
                [class.active]="frame_types.STYLE1 === _data.style_settings.frame.type">
                <!-- Frame 1 -->
                <svg viewBox="0 0 659 814">
                  <g id="QR-Generator" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Desktop-HD-Copy" transform="translate(-196.000000, -171.000000)">
                      <g id="Group-2" transform="translate(196.000000, 171.000000)">
                        <g id="Group">
                          <rect id="Rectangle" [attr.stroke]="_data.style_settings.frame.color" stroke-width="30" x="15"
                            y="15" width="629" height="784" rx="50"></rect>
                          <rect id="Rectangle" [attr.fill]="_data.style_settings.frame.color" x="23" y="633" width="615"
                            height="153"></rect>
                        </g>
                        <image x="89" y="89" width="481" height="481" xlink:href="assets/qr-generator/qr-code.png">
                        </image>
                        <text id="SCAN-ME" font-family="Poppins-Medium, Poppins" font-size="90" font-weight="400"
                          letter-spacing="0.375" fill="#FFFFFF">
                          <tspan x="127.4425" y="755">SCAN ME</tspan>
                        </text>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>

              <!-- Frame 2 -->
              <div class="frame" (click)="changeFrame(frame_types.STYLE2)"
                [class.active]="frame_types.STYLE2 === _data.style_settings.frame.type">
                <svg viewBox="0 0 659 866">
                  <g id="QR-Generator" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Desktop-HD-Copy" transform="translate(-1317.000000, -171.000000)">
                      <g id="Group-3" transform="translate(1317.000000, 171.000000)">
                        <rect id="Rectangle" [attr.stroke]="_data.style_settings.frame.color" stroke-width="30" x="15"
                          y="15" width="629" height="629" rx="50">
                        </rect>
                        <rect id="Rectangle" [attr.fill]="_data.style_settings.frame.color" x="0" y="689" width="659"
                          height="177" rx="88.5"></rect>
                        <image x="89" y="89" width="481" height="481" xlink:href="assets/qr-generator/qr-code.png">
                        </image>
                        <text id="SCAN-ME" font-family="Poppins-Medium, Poppins" font-size="90" font-weight="400"
                          letter-spacing="0.375" fill="#FFFFFF">
                          <tspan x="127.4425" y="809">SCAN ME</tspan>
                        </text>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>

              <!-- Frame 3 -->
              <div class="frame" (click)="changeFrame(frame_types.STYLE3)"
                [class.active]="frame_types.STYLE3 === _data.style_settings.frame.type">
                <svg viewBox="0 0 659 866">
                  <g id="QR-Generator" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Desktop-HD-Copy" transform="translate(-2416.000000, -191.000000)">
                      <g id="Group-4" transform="translate(2416.000000, 191.000000)">
                        <rect id="Rectangle" [attr.stroke]="_data.style_settings.frame.color" stroke-width="30" x="15"
                          y="222" width="629" height="629" rx="50">
                        </rect>
                        <rect id="Rectangle" [attr.fill]="_data.style_settings.frame.color" x="0" y="0" width="659"
                          height="177" rx="20"></rect>
                        <image x="89" y="296" width="481" height="481" xlink:href="assets/qr-generator/qr-code.png">
                        </image>
                        <text font-size="90" font-weight="400" letter-spacing="0.375" fill="#FFFFFF">
                          <tspan x="127.4425" y="120">SCAN ME</tspan>
                        </text>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>

              <!-- Frame 4 -->
              <div class="frame" (click)="changeFrame(frame_types.STYLE4)"
                [class.active]="frame_types.STYLE4 === _data.style_settings.frame.type">
                <svg viewBox="0 0 659 821">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(-196.000000, -1355.000000)">
                      <g transform="translate(196.000000, 1355.000000)">
                        <rect [attr.stroke]="_data.style_settings.frame.color" stroke-width="30" x="19.5" y="19.5"
                          width="620" height="620" rx="50"></rect>
                        <image x="89" y="89" width="481" height="481" xlink:href="assets/qr-generator/qr-code.png">
                        </image>
                        <text font-size="100" font-weight="400" letter-spacing="0.416666667"
                          [attr.fill]="_data.style_settings.frame.color">
                          <tspan x="105.491667" y="786">SCAN ME</tspan>
                        </text>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>

              <!-- Frame 5 -->
              <div class="frame" (click)="changeFrame(frame_types.STYLE5)"
                [class.active]="frame_types.STYLE5 == _data.style_settings.frame.type">
                <svg viewBox="0 0 817 1017">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(-1239.000000, -1355.000000)">
                      <g transform="translate(1239.000000, 1355.000000)">
                        <rect [attr.stroke]="_data.style_settings.frame.color" stroke-width="30" x="98.5" y="19.5"
                          width="620" height="620" rx="50"></rect>
                        <image x="168" y="89" width="481" height="481" xlink:href="assets/qr-generator/qr-code.png">
                        </image>
                        <g id="prize-banner-" transform="translate(0.000000, 689.000000)"
                          [attr.fill]="_data.style_settings.frame.color" fill-rule="nonzero">
                          <polygon id="Path"
                            points="113.724138 241.125 113.724138 207.6875 113.724138 94 0 94 80.2758621 201 0 308 194 308 194 241.125 140.482759 241.125">
                          </polygon>
                          <polygon id="Path"
                            points="817 94 702.935484 94 702.935484 207.6875 702.935484 241.125 676.096774 241.125 609 241.125 609 308 817 308 736.483871 201">
                          </polygon>
                          <rect id="Rectangle" x="142" y="0" width="535" height="214">
                          </rect>
                        </g>
                        <text font-size="90" font-weight="400" letter-spacing="0.375" fill="#FFFFFF">
                          <tspan x="206.4425" y="827">SCAN ME</tspan>
                        </text>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>

              <!-- Frame 6 -->
              <div class="frame" (click)="changeFrame(frame_types.STYLE6)"
                [class.active]="frame_types.STYLE6 === _data.style_settings.frame.type">
                <svg viewBox="0 0 659 1133">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(-2472.000000, -1218.000000)">
                      <g transform="translate(2472.000000, 1218.000000)">
                        <rect [attr.stroke]="_data.style_settings.frame.color" stroke-width="30" x="19.5" y="19.5"
                          width="620" height="1094" rx="100"></rect>
                        <image x="89" y="226" width="481" height="481" xlink:href="assets/qr-generator/qr-code.png">
                        </image>
                        <text font-size="90" font-weight="400" letter-spacing="0.375"
                          [attr.fill]="_data.style_settings.frame.color">
                          <tspan x="127.4425" y="847">SCAN ME</tspan>
                        </text>
                        <rect [attr.fill]="_data.style_settings.frame.color" x="289" y="79" width="81" height="20"
                          rx="10">
                        </rect>
                        <rect [attr.stroke]="_data.style_settings.frame.color" stroke-width="20" x="291" y="982"
                          width="77" height="77" rx="38.5"></rect>
                        <rect [attr.fill]="_data.style_settings.frame.color" x="28" y="137" width="603" height="30">
                        </rect>
                        <rect [attr.fill]="_data.style_settings.frame.color" x="28" y="909" width="603" height="30">
                        </rect>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingTwo">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#qr-code"
            aria-expanded="false" aria-controls="qr-code">
            <svg viewBox="0 0 512 512">
              <g>
                <path
                  d="m496 144c-8.837 0-16-7.164-16-16v-82c0-7.72-6.28-14-14-14h-82c-8.837 0-16-7.164-16-16s7.163-16 16-16h82c25.364 0 46 20.636 46 46v82c0 8.836-7.163 16-16 16z" />
                <path
                  d="m16 144c-8.837 0-16-7.164-16-16v-82c0-25.364 20.636-46 46-46h82c8.837 0 16 7.164 16 16s-7.163 16-16 16h-82c-7.72 0-14 6.28-14 14v82c0 8.836-7.163 16-16 16z" />
                <path
                  d="m128 512h-82c-25.364 0-46-20.636-46-46v-82c0-8.836 7.163-16 16-16s16 7.164 16 16v82c0 7.72 6.28 14 14 14h82c8.837 0 16 7.164 16 16s-7.163 16-16 16z" />
                <path
                  d="m466 512h-82c-8.837 0-16-7.164-16-16s7.163-16 16-16h82c7.72 0 14-6.28 14-14v-82c0-8.836 7.163-16 16-16s16 7.164 16 16v82c0 25.364-20.636 46-46 46z" />
                <path
                  d="m194 240h-84c-25.364 0-46-20.636-46-46v-84c0-25.364 20.636-46 46-46h84c25.364 0 46 20.636 46 46v84c0 25.364-20.636 46-46 46zm-84-144c-7.72 0-14 6.28-14 14v84c0 7.72 6.28 14 14 14h84c7.72 0 14-6.28 14-14v-84c0-7.72-6.28-14-14-14z" />
                <path
                  d="m194 448h-84c-25.364 0-46-20.636-46-46v-84c0-25.364 20.636-46 46-46h84c25.364 0 46 20.636 46 46v84c0 25.364-20.636 46-46 46zm-84-144c-7.72 0-14 6.28-14 14v84c0 7.72 6.28 14 14 14h84c7.72 0 14-6.28 14-14v-84c0-7.72-6.28-14-14-14z" />
                <path
                  d="m402 240h-84c-25.364 0-46-20.636-46-46v-84c0-25.364 20.636-46 46-46h84c25.364 0 46 20.636 46 46v84c0 25.364-20.636 46-46 46zm-84-144c-7.72 0-14 6.28-14 14v84c0 7.72 6.28 14 14 14h84c7.72 0 14-6.28 14-14v-84c0-7.72-6.28-14-14-14z" />
                <path
                  d="m422 352h-38v-54c0-14.336-11.663-26-26-26h-60c-14.337 0-26 11.664-26 26v60c0 14.336 11.663 26 26 26h54v38c0 14.336 11.663 26 26 26h44c14.337 0 26-11.664 26-26v-44c0-14.336-11.663-26-26-26zm-118-48h48v48h-48zm112 112h-32v-32h32z" />
                <path
                  d="m160 176h-16c-8.837 0-16-7.164-16-16v-16c0-8.836 7.163-16 16-16h16c8.837 0 16 7.164 16 16v16c0 8.836-7.163 16-16 16z" />
                <path
                  d="m368 176h-16c-8.837 0-16-7.164-16-16v-16c0-8.836 7.163-16 16-16h16c8.837 0 16 7.164 16 16v16c0 8.836-7.163 16-16 16z" />
                <path
                  d="m160 384h-16c-8.837 0-16-7.164-16-16v-16c0-8.836 7.163-16 16-16h16c8.837 0 16 7.164 16 16v16c0 8.836-7.163 16-16 16z" />
              </g>
            </svg>
            <b>QR CODE</b>
          </button>
        </h2>
        <div id="qr-code" class="accordion-collapse collapse" aria-labelledby="headingTwo"
          data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="row g-3 mb-3">
              <div class="col-md-6 col-sm-6">
                <div class="color-wrapper">
                  <label class="form-label">Code Color</label>
                  <div class="color-contents">
                    <div class="dropdown">
                      <div class="color-box"
                        [ngStyle]="{'background-color': _data.style_settings.qr_style.dotsOptions.color}"
                        id="colorDropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
                      <div class="dropdown-menu color-picker-dropdown p-3" aria-labelledby="colorDropdown">
                        <sketch-picker [control]="chromeControl2" class="sketch-picker">
                        </sketch-picker>
                      </div>
                    </div>
                    <input type="text" [(ngModel)]="_data.style_settings.qr_style.dotsOptions.color"
                      (change)="regenerateQR()" class="form-control">
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-6">
                <div class="color-wrapper">
                  <label class="form-label">Background Color</label>
                  <div class="color-contents">
                    <div class="dropdown">
                      <div class="color-box"
                        [ngStyle]="{'background-color': _data.style_settings.qr_style.backgroundOptions.color}"
                        id="colorDropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
                      <div class="dropdown-menu color-picker-dropdown p-3" aria-labelledby="colorDropdown">
                        <sketch-picker [control]="chromeControl3" class="sketch-picker">
                        </sketch-picker>
                      </div>
                    </div>
                    <input type="text" [(ngModel)]="_data.style_settings.qr_style.backgroundOptions.color"
                      (change)="regenerateQR()" class="form-control">
                  </div>
                </div>
              </div>
            </div>

            <div class="my-4">
              <hr>
            </div>

            <p>Shape Style</p>
            <div class="modal-frame-wrapper">
              <div class="frame"
                (click)="_data.style_settings.qr_style.dotsOptions.type = corner_options_mini.square; regenerateQR()"
                [class.active]="_data.style_settings.qr_style.dotsOptions.type == corner_options_mini.square">
                <img loading="lazy" src="assets/qr-generator/style_square.png" width="100%">
              </div>
              <div class="frame"
                (click)="_data.style_settings.qr_style.dotsOptions.type = corner_options.ROUNDED; regenerateQR()"
                [class.active]="_data.style_settings.qr_style.dotsOptions.type == corner_options.ROUNDED">
                <img loading="lazy" src="assets/qr-generator/style_rounded.png" width="100%">
              </div>
              <div class="frame"
                (click)="_data.style_settings.qr_style.dotsOptions.type = corner_options.DOTS; regenerateQR()"
                [class.active]="_data.style_settings.qr_style.dotsOptions.type == corner_options.DOTS">
                <img loading="lazy" src="assets/qr-generator/style_dots.png" width="100%">
              </div>
              <div class="frame"
                (click)="_data.style_settings.qr_style.dotsOptions.type = corner_options_mini['extra-rounded']; regenerateQR()"
                [class.active]="_data.style_settings.qr_style.dotsOptions.type == corner_options_mini['extra-rounded']">
                <img loading="lazy" src="assets/qr-generator/style_extra_rounded.png" width="100%">
              </div>
              <div class="frame"
                (click)="_data.style_settings.qr_style.dotsOptions.type = corner_options.CLASSY; regenerateQR()"
                [class.active]="_data.style_settings.qr_style.dotsOptions.type == corner_options.CLASSY">
                <img loading="lazy" src="assets/qr-generator/style_classy.png" width="100%">
              </div>
              <div class="frame"
                (click)="_data.style_settings.qr_style.dotsOptions.type = corner_options.CLASSY_ROUNDED; regenerateQR()"
                [class.active]="_data.style_settings.qr_style.dotsOptions.type == corner_options.CLASSY_ROUNDED">
                <img loading="lazy" src="assets/qr-generator/style_classy_rounded.png" width="100%">
              </div>
            </div>

            <div class="my-4">
              <hr>
            </div>

            <div class="edges-main-wrapper mt-3">
              <div class="row g-3 mb-3">
                <div class="col-lg-4 col-md-6 col-sm-5">
                  <div class="edges-wrapper">
                    <label class="form-label">Edges</label>
                    <div class="color-contents">
                      <div class="dropdown">
                        <div class="edges-box dropdown-toggle" id="edgesDropdown" data-bs-toggle="dropdown"
                          aria-haspopup="true" aria-expanded="false">

                          <div class="svg-wrapper">
                            <svg viewBox="0 0 179 179"
                              *ngIf="_data.style_settings.qr_style.cornersSquareOptions.type == corner_options_mini.square">
                              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g transform="translate(-974.000000, -341.000000)">
                                  <g id="Group-8" transform="translate(974.000000, 341.000000)">
                                    <rect id="Rectangle" stroke="#000000" stroke-width="25" x="14" y="14" width="151"
                                      height="151">
                                    </rect>
                                  </g>
                                </g>
                              </g>
                            </svg>

                            <svg viewBox="0 0 179 179"
                              *ngIf="_data.style_settings.qr_style.cornersSquareOptions.type == corner_options_mini['extra-rounded']">
                              <g id="QR-Generator" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g id="Desktop-HD-Copy" transform="translate(-531.000000, -2969.000000)">
                                  <g id="Group-8-Copy-8" transform="translate(531.000000, 2969.000000)">
                                    <rect id="Rectangle" stroke="#000000" stroke-width="25" x="12.5" y="12.5"
                                      width="154" height="154" rx="60"></rect>
                                  </g>
                                </g>
                              </g>
                            </svg>

                            <svg viewBox="0 0 179 179"
                              *ngIf="_data.style_settings.qr_style.cornersSquareOptions.type == corner_options_mini.dot">
                              <g id="QR-Generator" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g id="Desktop-HD-Copy" transform="translate(-531.000000, -2969.000000)">
                                  <g id="Group-8-Copy-8" transform="translate(531.000000, 2969.000000)">
                                    <rect id="Rectangle" stroke="#000000" stroke-width="25" x="12.5" y="12.5"
                                      width="154" height="154" rx="100">
                                    </rect>
                                  </g>
                                </g>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <div class="dropdown-menu p-3" aria-labelledby="edgesDropdown">

                          <div class="edges-style-wrapper">

                            <!-- Style 1 -->
                            <div class="edge"
                              [class.active]="_data.style_settings.qr_style.cornersSquareOptions.type == corner_options_mini.square"
                              (click)="_data.style_settings.qr_style.cornersSquareOptions.type = corner_options_mini.square; regenerateQR()">
                              <svg viewBox="0 0 179 179">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                  <g transform="translate(-974.000000, -341.000000)">
                                    <g id="Group-8" transform="translate(974.000000, 341.000000)">
                                      <rect id="Rectangle" stroke="#000000" stroke-width="25" x="14" y="14" width="151"
                                        height="151"></rect>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                            </div>

                            <!-- Style 2 -->
                            <div class="edge"
                              [class.active]="_data.style_settings.qr_style.cornersSquareOptions.type == corner_options_mini['extra-rounded']"
                              (click)="_data.style_settings.qr_style.cornersSquareOptions.type = corner_options_mini['extra-rounded']; regenerateQR()">
                              <svg viewBox="0 0 179 179">
                                <g id="QR-Generator" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                  <g id="Desktop-HD-Copy" transform="translate(-531.000000, -2969.000000)">
                                    <g id="Group-8-Copy-8" transform="translate(531.000000, 2969.000000)">
                                      <rect id="Rectangle" stroke="#000000" stroke-width="25" x="12.5" y="12.5"
                                        width="154" height="154" rx="60">
                                      </rect>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                            </div>

                            <!-- Style 3 -->
                            <div class="edge"
                              [class.active]="_data.style_settings.qr_style.cornersSquareOptions.type == corner_options_mini.dot"
                              (click)="_data.style_settings.qr_style.cornersSquareOptions.type = corner_options_mini.dot; regenerateQR()">
                              <svg viewBox="0 0 179 179">
                                <g id="QR-Generator" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                  <g id="Desktop-HD-Copy" transform="translate(-531.000000, -2969.000000)">
                                    <g id="Group-8-Copy-8" transform="translate(531.000000, 2969.000000)">
                                      <rect id="Rectangle" stroke="#000000" stroke-width="25" x="12.5" y="12.5"
                                        width="154" height="154" rx="100">
                                      </rect>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                            </div>

                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-8 col-md-6 col-sm-7">
                  <div class="color-wrapper">
                    <label class="form-label">Edges Color</label>
                    <div class="color-contents">
                      <div class="dropdown">
                        <div class="color-box"
                          [ngStyle]="{'background-color': _data.style_settings.qr_style.cornersSquareOptions.color}"
                          id="colorDropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
                        <div class="dropdown-menu color-picker-dropdown p-3" aria-labelledby="colorDropdown">
                          <sketch-picker [control]="chromeControl4" class="sketch-picker">
                          </sketch-picker>
                        </div>
                      </div>
                      <input type="text" [(ngModel)]="_data.style_settings.qr_style.cornersSquareOptions.color"
                        (change)="regenerateQR()" class="form-control">
                    </div>
                  </div>
                </div>
              </div>

              <div class="my-4">
                <hr>
              </div>

              <div class="row g-3 mb-3">
                <div class="col-lg-4 col-md-6 col-sm-5">
                  <div class="edges-wrapper">
                    <label class="form-label">Inner Edges</label>
                    <div class="color-contents">
                      <div class="dropdown">
                        <div class="edges-box dropdown-toggle" id="edgesDropdown1" data-bs-toggle="dropdown"
                          aria-haspopup="true" aria-expanded="false">

                          <div class="svg-wrapper">
                            <svg
                              *ngIf="_data.style_settings.qr_style.cornersDotOptions.type == corner_options_mini.square"
                              viewBox="0 0 179 179">
                              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g transform="translate(-1626.000000, -2898.000000)" fill="#000000">
                                  <rect id="Rectangle-Copy" x="1626" y="2898" width="179" height="179"></rect>
                                </g>
                              </g>
                            </svg>

                            <svg *ngIf="!_data.style_settings.qr_style.cornersDotOptions.type" viewBox="0 0 179 179">
                              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g transform="translate(-1626.000000, -2898.000000)" fill="#000000">
                                  <rect id="Rectangle-Copy" x="1626" y="2898" width="179" height="179" rx="50"></rect>
                                </g>
                              </g>
                            </svg>

                            <svg *ngIf="_data.style_settings.qr_style.cornersDotOptions.type == corner_options_mini.dot"
                              viewBox="0 0 179 179">
                              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g transform="translate(-1626.000000, -2898.000000)" fill="#000000">
                                  <rect id="Rectangle-Copy" x="1626" y="2898" width="179" height="179" rx="150"></rect>
                                </g>
                              </g>
                            </svg>
                          </div>
                        </div>
                        <div class="dropdown-menu p-3" aria-labelledby="edgesDropdown1">

                          <div class="edges-style-wrapper">

                            <!-- Style 1 -->
                            <div class="edge"
                              [class.active]="_data.style_settings.qr_style.cornersDotOptions.type == corner_options_mini.square"
                              (click)="_data.style_settings.qr_style.cornersDotOptions.type = corner_options_mini.square; regenerateQR()">
                              <svg viewBox="0 0 179 179">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                  <g transform="translate(-1626.000000, -2898.000000)" fill="#000000">
                                    <rect id="Rectangle-Copy" x="1626" y="2898" width="179" height="179"></rect>
                                  </g>
                                </g>
                              </svg>
                            </div>

                            <!-- Style 2 -->
                            <div class="edge" [class.active]="!_data.style_settings.qr_style.cornersDotOptions.type"
                              (click)="_data.style_settings.qr_style.cornersDotOptions.type = null; regenerateQR()">
                              <svg viewBox="0 0 179 179">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                  <g transform="translate(-1626.000000, -2898.000000)" fill="#000000">
                                    <rect id="Rectangle-Copy" x="1626" y="2898" width="179" height="179" rx="50"></rect>
                                  </g>
                                </g>
                              </svg>
                            </div>

                            <!-- Style 3 -->
                            <div class="edge"
                              [class.active]="_data.style_settings.qr_style.cornersDotOptions.type == corner_options_mini.dot"
                              (click)="_data.style_settings.qr_style.cornersDotOptions.type = corner_options_mini.dot; regenerateQR()">
                              <svg viewBox="0 0 179 179">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                  <g transform="translate(-1626.000000, -2898.000000)" fill="#000000">
                                    <rect id="Rectangle-Copy" x="1626" y="2898" width="179" height="179" rx="150">
                                    </rect>
                                  </g>
                                </g>
                              </svg>
                            </div>

                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-8 col-md-6 col-sm-7">
                  <div class="color-wrapper">
                    <label class="form-label">Inner Edges Color</label>
                    <div class="color-contents">
                      <div class="dropdown">
                        <div class="color-box"
                          [ngStyle]="{'background-color': _data.style_settings.qr_style.cornersDotOptions.color}"
                          id="colorDropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
                        <div class="dropdown-menu color-picker-dropdown p-3" aria-labelledby="colorDropdown">
                          <sketch-picker [control]="chromeControl5" class="sketch-picker">
                          </sketch-picker>
                        </div>
                      </div>
                      <input type="text" [(ngModel)]="_data.style_settings.qr_style.cornersDotOptions.color"
                        (change)="regenerateQR()" class="form-control">
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header" id="headingThree">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#qr-image"
            aria-expanded="false" aria-controls="qr-image">
            <i class="bi bi-image"></i>
            <b>LOGO</b>
          </button>
        </h2>
        <div id="qr-image" class="accordion-collapse collapse" aria-labelledby="headingThree"
          data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="modal-frame-wrapper">

              <div class="frame" (click)="_data.style_settings.qr_middle_logo_id = ''; regenerateQR();"
                [ngClass]="{'active processing': !_data.style_settings.qr_middle_logo_id && !file_helper.showing}">
                <i class="bi bi-slash-circle"></i>
              </div>
              <div class="frame"
                (click)="_data.style_settings.qr_middle_logo_id = logo.id; file_helper.showing = false; regenerateQR();"
                [ngClass]="{'active processing': logo.id === _data.style_settings.qr_middle_logo_id && !file_helper.showing}"
                *ngFor="let logo of session_info.resources.qr_logos">
                <app-svg-icon *ngIf="logo.svg; else hasUrl" [svg]="logo"
                  [color]="_data.style_settings.qr_style.dotsOptions.color"
                  [event_color]="primary_color_obs.asObservable()">
                </app-svg-icon>
                <ng-template #hasUrl>
                  <img loading="lazy" [src]="logo.url" width="35">
                </ng-template>
              </div>

              <div class="frame" [class.active]="custom_logo_id === _data.style_settings.qr_middle_logo_id"
                (click)="_data.style_settings.qr_middle_logo_id = custom_logo_id; regenerateQR();"
                *ngIf="file_helper.input_url; else noFileSelectedYet">
                <img loading="lazy" [src]="file_helper.input_url | safeUrl" width="50">
                <div class="delete">
                  <i (click)="finishImageUpload(true)" class="bi bi-trash"></i>
                </div>
              </div>
              <ng-template #noFileSelectedYet>
                <div class="frame" (click)="file_helper.showing = !file_helper.showing">
                  <i class="bi bi-plus"></i>
                </div>
              </ng-template>
            </div>
            <div class="animated fadeIn" *ngIf="file_helper.showing">
              <div class="pt-5">
                <div class="uploader">
                  <input id="file-upload" #myFileInput (change)="fileChangeEvent($event);" type="file" name="fileUpload"
                    accept="image/*">
                  <label for="file-upload" appDragndrop (onFileDropped)="fileChangeEvent($event)" id="file-drag">
                    <div class="py-3">
                      <img loading="lazy" src="assets/image-upload.png">
                    </div>
                    <p>Drag and drop logo here or</p>
                    <span id="file-upload-btn" class="btn btn-secondary">Select a
                      file</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-5 text-center">
      <button class="btn btn-success btn-sm" (click)="download()">
        <i class="bi bi-download me-2"></i> PNG
      </button>
      <button class="btn btn-warning btn-sm mx-2" (click)="download(file_downloadable_types.JPEG)">
        <i class="bi bi-download me-2"></i> JPG
      </button>
      <button class="btn btn-info btn-sm" (click)="download(file_downloadable_types.SVG)">
        <i class="bi bi-download me-2"></i> SVG
      </button>
    </div>
  </ng-template>
</div>